/**
 * Centralized auth token utility
 * Checks for impersonation token first, then falls back to Clerk token
 */

const IMPERSONATION_STORAGE_KEY = 'impersonation_state';

export async function getAuthToken(): Promise<string | null> {
  // Check for impersonation token first
  try {
    const stored = localStorage.getItem(IMPERSONATION_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed.isImpersonating && parsed.impersonationToken) {
        return parsed.impersonationToken;
      }
    }
  } catch (error) {
    console.error('Error reading impersonation state:', error);
  }

  // Fall back to Clerk token
  try {
    // Check if Clerk is available
    if (!(window as any).Clerk) {
      console.warn('Clerk not available on window object');
      return null;
    }
    
    // Check if session exists
    if (!(window as any).Clerk.session) {
      console.warn('Clerk session not available');
      return null;
    }
    
    // Get token with timeout
    const tokenPromise = (window as any).Clerk.session.getToken();
    const timeoutPromise = new Promise((_, reject) => 
      setTimeout(() => reject(new Error('Token request timeout')), 5000)
    );
    
    const token = await Promise.race([tokenPromise, timeoutPromise]) as string;
    return token || null;
  } catch (error) {
    console.error('Error getting auth token:', error);
    return null;
  }
}








